sealed class GameScreenEvent {
    data object PlayerWasKicked : GameScreenEvent()
    data object GameUnavailable : GameScreenEvent()
    data object GameFinished : GameScreenEvent()
    data class GameFinishedWithMessage(val message: String) : GameScreenEvent()
    data class ShowSnackbar(val message: String) : GameScreenEvent()

    /**
     * The practice round was played through its final round. The screen skips the usual game-over
     * ceremony (no interstitial, no review prompt) and returns to the start screen, where the dice
     * picker opens on the freshly earned Training Wheels.
     */
    data class PracticeCompleted(val unlockedTrainingDice: Boolean) : GameScreenEvent()
}
